import {alertFormMixin} from './alertFormMixin.js';

export default () => Object.defineProperties({
    init() {
        this.$nextTick(() => {
            this.$el.querySelector('form').addEventListener('ajax:before', () => this.addEmailFromEditable());
        });
    },
}, Object.getOwnPropertyDescriptors(alertFormMixin));
